import { render, staticRenderFns } from "./AccountAdminUserTable.vue?vue&type=template&id=066ed400&"
import script from "./AccountAdminUserTable.vue?vue&type=script&lang=js&"
export * from "./AccountAdminUserTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports